/* script */
//
//
//
//
//
//
//
//
//
//
//
//

// Utils
import { get } from 'lodash';

// Components
import AuthContainer from './AuthContainer.vue';
import TelephoneInput from 'shared/ui/components/form-components/TelephoneInput.vue';

const __vue_script__ = {
    name: 'MFAPhoneQuery',

    components: { AuthContainer, TelephoneInput },

    data() {
        return {
            errorMessage: '',
            errors: [],
            verifying: false,
            phone: '',
            phoneToken: '',
        };
    },

    created() {
        this.phoneToken = this.$route.query.phone_request_token;
    },

    methods: {
        async verify() {
            this.errors = [];
            this.verifying = true;
            this.errorMessage = '';
            try {
                const data = await this.$services.session.sendMFAPhone(this.phone, this.phoneToken);
                this.$router.push({ path: this.$const.ROUTE_LOGIN_WITH_MFA, query: { mfa_token: data.mfa_token, phone_digits: data.phone_digits } });
            } catch (error) {
                const err = get(error, 'response.data.error', {});
                this.verifying = false;

                const errorCode = err.error_type ?? 'generic_try_again';
                this.errorMessage = this.$i18n.t(`login.errors.${errorCode}`);
            }
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('auth-container',[_c('div',{staticClass:"mfa-phone-query"},[_c('validation-observer',{attrs:{"slim":true},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var handleSubmit = ref.handleSubmit;
return [_c('form',{staticClass:"mfa-prompt",attrs:{"aria-label":_vm.$t('login.forms.mfa.phone')},on:{"submit":function($event){$event.preventDefault();return handleSubmit(_vm.verify)}}},[(_vm.errorMessage)?_c('div',{staticClass:"alert alert-info"},[_c('p',[_vm._v(_vm._s(_vm.errorMessage))])]):_vm._e(),_c('div',{staticClass:"text-prompt"},[_vm._v(_vm._s(_vm.$t('login.forms.mfa.enter_phone')))]),_c('validation-provider',{attrs:{"rules":"required","slim":true,"name":"phone"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('telephone-input',{staticClass:"name",attrs:{"placeholder":_vm.$t('login.forms.mfa.phone_field'),"type":"text","name":"phone","errors":errors,"autocomplete":"tel"},model:{value:(_vm.phone),callback:function ($$v) {_vm.phone=$$v},expression:"phone"}})]}}],null,true)}),_c('button',{staticClass:"btn btn-login",attrs:{"disabled":_vm.verifying}},[_vm._v(_vm._s(_vm.$t('login.links.send_code' )))])],1)]}}])})],1)])}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "MFAPhoneQuery.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__